import oneSaga from './oneSaga'
import listSaga from './listSaga'

const companySubscriptionsSagas = [oneSaga(), listSaga()]

export default companySubscriptionsSagas
